if (!customElements.get('products-slider')) {
  class ProductsSlider extends HTMLElement {
    constructor() {
      super();
      this.options = {
        slidesPerView: 2.15,
        slidesPerGroup: 2,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        loop: false,
        spaceBetween: 10,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'fraction',
          clickable: true,
        },
        breakpoints: {
          990: {
            spaceBetween: 20,
            slidesPerView: 2,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      };
    }

    connectedCallback() {
      const element = this.querySelector('[data-slider]');

      if (!element || !Swiper) return;

      this.slider = new Swiper(element, this.options);
    }
  }
  customElements.define('products-slider', ProductsSlider);
}
